import React from 'react';
import { Link } from 'react-router-dom';
import BenefitBox from '../components/BenefitBox';
import duurzameOplossing from '../images/DuurzameOplossing.svg';
import profileImage from '../images/OverOnsJesseVanDijk.png';

const OverOns = () => {
  return (
    <main className="bg-white">
      {/* Hero Section with Image */}
      <section className="hero bg-white">
        <div className="hero-content max-w-2xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Een Interim Agile Specialist</h1>
          <p className="text-gray-700 mb-8 leading-relaxed">
            Als ervaren Agile professional help ik organisaties bij het ontwikkelen van producten 
            en het verbeteren van processen. Mijn kracht ligt in het oplossen van complexe 
            vraagstukken door heldere communicatie en een pragmatische aanpak. Met meer dan 8 jaar 
            ervaring combineer ik technische kennis met een scherp oog voor de menselijke kant 
            van verandering.
          </p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn-primary">Contact</Link>
          </div>
        </div>
        <div className="hero-image">
          <img 
            src={profileImage}
            alt="Jesse van Dijk - Agile Professional" 
            className="rounded-lg shadow-lg w-full h-96 object-cover"
          />
        </div>
      </section>

      {/* Why Choose Section with Image and 4 Boxes */}
      <section className="why-choose-section">
        <div className="why-choose-grid">
          <div className="why-choose-left">
            <div className="sticky-content">
              <h2 className="orange-text">Een partner in verandering</h2>
              <h1 className="blue-title">
                Complexe uitdagingen<br />
                omzetten naar<br />
                duurzame<br />
                oplossingen<span className="blue-dot">.</span>
              </h1>
              <div className="solution-image-container">
                <img 
                  src={duurzameOplossing} 
                  alt="Duurzame Oplossingen Visualisatie" 
                  className="solution-image"
                />
              </div>
            </div>
          </div>
          <div className="why-choose-right benefits-grid">
            <BenefitBox
              title="Verbinding tussen Business & IT"
              description="Als ervaren Agile professional verbind ik business en IT door heldere communicatie en wederzijds begrip. Mijn achtergrond in beide werelden stelt mij in staat om technische complexiteit te vertalen naar bedrijfswaarde, en bedrijfsbehoeften om te zetten in concrete oplossingen."
            />
            <BenefitBox
              title="Pragmatische Agile Aanpak"
              description="Ik geloof in het praktisch toepassen van Agile principes, aangepast aan de context van uw organisatie. Door mijn hands-on ervaring help ik teams om complexe uitdagingen behapbaar te maken en tastbare resultaten te behalen, zonder de flexibiliteit uit het oog te verliezen."
            />
            <BenefitBox
              title="Focus op Business Value"
              description="Door mijn ervaring als Product Owner en Business Analist leg ik de focus altijd op het creëren van echte business value. Ik help organisaties om strategische doelen te vertalen naar concrete resultaten die impact maken."
            />
            <BenefitBox
              title="Duurzame Verandering"
              description="Verandering is meer dan alleen processen aanpassen. Ik focus op het creëren van duurzame verandering door mensen mee te nemen in de transformatie en te zorgen voor blijvende verbeteringen in de manier van werken."
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default OverOns;